import React from 'react'

export class CommonColors {
  static transparent = 'transparent'
  static shadow = '#000000'
  static shadow1 = '#292D32'
  static shadow3 = 'rgba(0, 0, 0, 0.45)'
  static shadow2 = '#072941'
  static shadow4 = 'rgba(0, 0, 0, 0.85)'
  static shadow5 = 'rgba(0, 0, 0, 0.25)'
  static white = '#ffffff'
  static yellow = '#FFD610'
  static orange = '#FF9901'
  static blue = '#01ACFF'
  static blue1 = 'rgba(0, 163, 255, 0.05)'
  static blue2 = '#1890FF'
  static blue3 = '#E5F2FF'
  static primary = '#1890FF'
  static primaryHover = '#096DD9'
  static secondary = '#003D75'
  static backgroundBase = '#E5F2FF'
}
